{
  "id": "twitter.com",
  "version": 1,
  "name": "Twitter / X",
  "author": "SR",
  "date": "2023-07-04",
  "url": "https://www.twitter.com",
  "strings": {
    "en": {
      "name": "Twitter / X",
      "help": [
        "https://twitter.com/settings/your_twitter_data",
        "(Log in with your Twitter/X Account)",
        "On the right side select 'Download archive'",
        "Enter your password and click 'Confirm'",
        "Then click on 'Request archive'",
        "(If you created an archive in the last 30 days you can now click 'Download data')",
        "Wait for the Email and follow the instructions (can take up to 2 days to arrive)"
      ]
    },
    "de": {
      "name": "Twitter / X",
      "help": [
        "https://twitter.com/settings/your_twitter_data.",
        "(Melde dich mit deinem Twitter/X Konto an)",
        "Gebe auf der rechten Bildschirmseite dein Password ein und klicke auf 'Bestätigen'",
        "Klicke anschließend auf 'Archiv herunterladen'.",
        "(sollten  in den letzten 30 Tage bereits ein Archiv erstellt haben können Sie jetzt 'Daten herunterladen' klicken)",
        "Du erhältst eine Email zum Herunterladen (kann bis zu 2 Tagen dauern)"
      ]
    }
  },
  "instructions": [],
  "fileStructure": ["data/", "assets/", "Your archive.html"],
  "optionalFileStructure": []
}
